import { EnPaperSize } from '@medlogic/shared/shared-interfaces';
import { EnPaperOrientation } from '@medlogic/shared/shared-interfaces';
import { Injectable } from '@angular/core';
import { LogService } from '@medlogic/shared/shared-interfaces';
import { GlobalService } from '@medlogic/shared/shared-interfaces';
import { EnTypedValue } from '@medlogic/shared/shared-interfaces';
import { Observable } from 'rxjs';

// declare let jsPDF;
import * as html2canvas from 'html2canvas';
// import 'jspdf-autotable';
// Resultado desejado com os imports;
// import { jsPDF } from 'jspdf';
// require('jspdf-autotable');
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';

@Injectable()
export class PdfGeneratorService {

	constructor(public log: LogService, public glb: GlobalService) { }

	/* Prepara o conteúdo do html para o componente de geração de PDF.
	* doc: resgate um html pelo id da tag com algo do tipo:  let doc = document.getElementById('contentToConvert');
	* isAutoPrint: determinará se quando o PDF for aberto a impressão será chamada automaticamente.
	*/
	generatePDF(
		title: string,
		docHtml: any,
		enPaperOrientation: EnPaperOrientation = EnPaperOrientation.Portrait,
		imgWidth: number = 208,
		isAutoPrint: boolean = true
	): Observable<any> {
		try {
			return new Observable((observer) => {
				title = this.glb.removeDiacritics(this.glb.ReplaceAll(title, ' ', '-').trim());
				const doc = new jsPDF(enPaperOrientation, 'mm', 'a4');
				const margins = {
					top: 15,
					bottom: 10,
					left: 10,
					right: 10,
					useFor: 'page'
				};
				html2canvas.default(docHtml).then((canvas) => {
					try {
						imgWidth = 210 - margins.left - margins.right;
						const pageHeight = 295;
						const imgHeight = canvas.height * imgWidth / canvas.width - margins.top - margins.bottom;
						const contentDataURL = canvas.toDataURL('image/png');
						let heightLeft = imgHeight;
						let position = margins.top;
						doc.addImage(contentDataURL, 'PNG', margins.left, position, imgWidth, imgHeight);
						heightLeft -= pageHeight;
						const data = this.glb.dateToddMMYYYYhhmmss(new Date()).replace(/\//g, '');
						doc.autoPrint();
						let page = 1;
						while (heightLeft >= 0) {
							position = heightLeft - imgHeight;
							doc.addPage();
							// tslint:disable-next-line: max-line-length
							const imgData =
								'data:image/png;base64,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';
							// doc.setFontSize(40)
							// doc.text(35, 25, `Página ${page}`);
							doc.addImage(imgData, 'PNG', 0, position, imgWidth, 22.5);
							doc.addImage(contentDataURL, 'PNG', margins.left, position, imgWidth, imgHeight);
							page++;
							heightLeft -= pageHeight;
						}
						doc.save(`${title}${data}.pdf`);
						observer.next(true);
						observer.complete();
					} catch (error) {
						this.log.Registrar(this.constructor.name, 'generatePDF.then', error.message);
					}
					// return null;
					// doc.addHTML(
					//     canvas,
					//     10,
					//     10,
					//     { pagesplit: true, margin: margins },
					//     // doc.fromHTML(docHtml,
					//     // margins.left, // x coord
					//     // margins.top, { pagesplit: false },
					//     function (dispose) {
					//         doc.save(`${title}${data}.pdf`);
					//         observer.next(true);
					//         observer.complete();
					//     }
					// );
				});
			});
		} catch (error) {
			this.log.Registrar(this.constructor.name, 'generatePDF', error.message);
		}
	}


	generateEvolutionPDF(
		title: string,
		docHtml: any,
		enPaperOrientation: EnPaperOrientation = EnPaperOrientation.Portrait,
		imgWidth: number = 208,
		isAutoPrint: boolean = true
	): void {
		try {
			const doc = new jsPDF(enPaperOrientation, 'mm', 'a2');
			const margins = {
				top: 15,
				bottom: 10,
				left: 10,
				right: 10,
				useFor: 'page'
			};
			// doc.html(docHtml);
			// doc.save(`${title}.pdf`);
			doc.html(docHtml, {
				filename: `${title}.pdf`,
				margin: [0, 0, 0, 0],
				callback: (res: any) => {
					res.save();
				},
				x: 0,
				y: 0
			});
		} catch (error) {
			this.log.Registrar(this.constructor.name, 'generatePDF', error.message);
		}
	}





	/*Deve se informada uma tabela html. Era será convertida em json, em seguida,
	   * gerado um pdf, com paginação.
	   */
	generatePdfFromTable(
		title: string,
		tableHtml: HTMLTableElement,
		bottomHtml: Element,
		bottomManipulationFunc: Function,
		enPaperOrientation: EnPaperOrientation = EnPaperOrientation.Portrait,
		imgWidth: number = 208,
		enPaperSize: EnPaperSize = EnPaperSize.a4,
		isAutoPrint: boolean = true,
		fontSize: number = 10,
		topMargin: number = 30,
		footerText: string = null
	): Observable<any> {
		try {
			return new Observable((observer) => {
				try {
					// const step = 20;
					// const fileName = this.glb.removeDiacritics(this.glb.ReplaceAll(title, ' ', '-').trim());
					// // TODO: esse é o nome do objeto criado pelo script jsPDF chamado na home. Em função do plugin, não soube como instalar adequadamente e usar o import.
					// const doc = new jsPDF(enPaperOrientation, 'mm', enPaperSize);
					// const data = this.glb.dateToddMMYYYYhhmmss(new Date()).replace(/\//g, '');
					// const margins = {
					// 	top: 15,
					// 	bottom: 10,
					// 	left: 10,
					// 	right: 10,
					// 	useFor: 'page'
					// };
					// // const res = autoTableHtmlToJson(doc, tableHtml);
					// autoTable(doc, {
					// 	html: tableHtml,
					// 	didDrawCell: (res) => {
					// 		if (res.column) {
					// 			const header = (dataHeader: any) => {
					// 				doc.setFontSize(18);
					// 				doc.setTextColor(40);
					// 				// doc.setFontStyle('normal');
					// 				// doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
					// 				const splitTitle = doc.splitTextToSize(title, 650);
					// 				doc.text(splitTitle, dataHeader.settings.margin.left, margins.top);
					// 			};
					// 			const columns: string[] = res.column.map((m) => {
					// 				return m.innerText || '';
					// 			});
					// 			// Analisa algumas caraterísicas da primeira linha para determinar o estilo
					// 			const columnStyles = {};
					// 			// res.data[0].forEach((m, index) => {
					// 			// 	const typed = this.glb.getTypedValue(m.innerText);
					// 			// 	switch (typed.type) {
					// 			// 		case EnTypedValue.Date:
					// 			// 			columnStyles[index] = { cellWidth: 25 }; //  fillColor: 'blue'
					// 			// 			break;
					// 			// 		default:
					// 			// 			columnStyles[index] = { cellWidth: 'wrap' };
					// 			// 			break;
					// 			// 	}
					// 			// });
					// 			const headerHeight = 20;
					// 			const options = {
					// 				margin: {
					// 					top: margins.top + headerHeight,
					// 					bottom: 60
					// 				},
					// 				addPageContent: header,
					// 				startY: margins.top + headerHeight,
					// 				head: [columns],
					// 				body: res.data,
					// 				columnStyles
					// 			};
					// 			doc.setFontSize(fontSize);
					// 			autoTable(doc, options);
					// 			if (bottomManipulationFunc) {
					// 				footerText = bottomManipulationFunc.call(this, bottomHtml, doc, footerText);
					// 			}
					// 			if (isAutoPrint) {
					// 				doc.autoPrint();
					// 			}
					// 			doc.save(`${fileName}${data}.pdf`);
					// 			observer.next(true);
					// 		} else {
					// 			observer.next(false);
					// 		}
					// 	}
					// });
					// observer.complete();
				} catch (error) {
					this.log.Registrar(this.constructor.name, 'generatePdfFromTable.Observable', error.message);
				}
			});
		} catch (error) {
			this.log.Registrar(this.constructor.name, 'generatePdfFromTable', error.message);
		}
	}

	/*Deve se informados os dados em arrays sendo head os nomes das colunas e body cada linha.
	* Será gerado um pdf, com paginação.
	*/
	generatePdfFromData(
		title: string,
		head: string[],
		body: string[][],
		bottomHtml: Element,
		bottomManipulationFunc: Function,
		enPaperOrientation: EnPaperOrientation = EnPaperOrientation.Portrait,
		imgWidth: number = 208,
		enPaperSize: EnPaperSize = EnPaperSize.a4,
		isAutoPrint: boolean = true,
		fontSize: number = 10,
		topMargin: number = 10,
		footerText: string = null
	): Observable<any> {
		try {
			return new Observable((observer) => {
				try {
					const step = 20;
					const fileName = this.glb.removeDiacritics(this.glb.ReplaceAll(title, ' ', '-').trim());
					// TODO: esse é o nome do objeto criado pelo script jsPDF chamado na home. Em função do plugin, não soube como instalar adequadamente e usar o import.
					const doc = new jsPDF(enPaperOrientation, 'mm', enPaperSize);
					const data = this.glb.dateToddMMYYYYhhmmss(new Date()).replace(/\//g, '');
					const margins = {
						top: 15,
						bottom: 10,
						left: 10,
						right: 10,
						useFor: 'page'
					};
					if (head && head.length > 0) {
						const header = (dataHeader: any) => {
							doc.setFontSize(18);
							doc.setTextColor(40);
							// doc.setFontStyle('normal');
							const splitTitle = doc.splitTextToSize(title, 650);
							doc.text(splitTitle, dataHeader.settings.margin.left, margins.top);
						};
						const headerHeight = 40;
						const options = {
							margin: {
								top: 40,
								bottom: 80
							},
							setFontSize: fontSize,
							addPageContent: header,
							startY: margins.top + headerHeight,
							head: [head],
							body
						};
						// showHead: 'firstPage',
						// styles: { overflow: 'hidden' }
						// pageBreak: 'auto',
						// rowPageBreak: 'auto',
						doc.setFontSize(fontSize);
						autoTable(doc, options);
						if (bottomManipulationFunc) {
							footerText = bottomManipulationFunc.call(this, bottomHtml, doc, footerText);
						}
						if (isAutoPrint) {
							doc.autoPrint();
						}
						doc.save(`${fileName}${data}.pdf`);
						observer.next(true);
					} else {
						observer.next(false);
					}
					observer.complete();
				} catch (error) {
					this.log.Registrar(this.constructor.name, 'generatePdfFromTable.Observable', error.message);
				}
			});
		} catch (error) {
			this.log.Registrar(this.constructor.name, 'generatePdfFromTable', error.message);
		}
	}

	/*Cria o rodapé para o relatório financeiro. */
	finantialGridBottomCreate(bottomHtml: Element, doc: any, footerText: string): void {
		try {
			if (bottomHtml) {
				let text = bottomHtml.textContent;
				let despesa: string;
				let receita: string;
				let saldo: string;
				let transporteSaldo: string;
				doc.setFontSize(18);
				doc.setFont('Helvetica');
				doc.setTextColor(40);
				if (text.indexOf('TRANSPORTE') === -1) {
					text = text.substring(text.indexOf('DESPESA'));
					despesa = text.substring(0, text.indexOf('RECEITA') - 1);
					receita = text.substring(text.indexOf('RECEITA'), text.indexOf('SALDO:') - 1);
					saldo = text.substring(text.indexOf('SALDO'));
					doc.text(20, doc.autoTableEndPosY() + 20, despesa);
					doc.text(20, doc.autoTableEndPosY() + 30, receita);
					doc.setFontStyle('bold');
					doc.text(20, doc.autoTableEndPosY() + 40, saldo);
				} else {
					text = text.substring(text.indexOf('TRANSPORTE'));
					transporteSaldo = text.substring(0, text.indexOf('DESPESA') - 1);
					text = text.substring(text.indexOf('SALDO') + 1);
					despesa = text.substring(text.indexOf('DESPESA'), text.indexOf('RECEITA') - 1);
					receita = text.substring(text.indexOf('RECEITA'), text.indexOf('SALDO:') - 1);
					saldo = text.substring(text.indexOf('SALDO'));
					doc.text(20, doc.previousAutoTable.finalY + 20, transporteSaldo);
					doc.text(20, doc.previousAutoTable.finalY + 30, despesa);
					doc.text(20, doc.previousAutoTable.finalY + 40, receita);
					doc.setFontStyle('bold');
					doc.text(20, doc.previousAutoTable.finalY + 50, saldo);
				}
				if (!this.glb.isNullOrEmpty(footerText)) {
					footerText = doc.splitTextToSize(footerText, 400);
					const posY = doc.previousAutoTable.finalY + 100;
					// if (posY >= 450) { // Se não for caber o conteúdo no final da página, quebra a página.
					//   doc.addPage();
					//   posY += 100;
					// }
					doc.text(6, posY, footerText);
				}
			}
		} catch (error) {
			this.log.Registrar(this.constructor.name, 'finantialGridBottomCreate', error.message);
		}
	}


}
